module.exports = __webpack_public_path__ + "img/user-circle.595dc71f.svg";